<template>
  <div>
    <a-row v-if="status === 131" style="margin-bottom: 5px">
      <a-col v-if="status === 131" :span="16">
        <a-alert style="max-width: 600px" message="完成撰写MRD后,请前往【详细信息】TAB中进行提交MRD审批" type="warning" show-icon />
      </a-col>
      <a-col>
        <div style="text-align: right">
          <a-button v-if="dataSource.length > 0 && status === 131" v-tc="{ name: '解除MRD' }" type="primary" @click="onDisassociate">解除MRD</a-button>
        </div>
      </a-col>
    </a-row>
    <document-edit ref="documentEdit" @ok="onReload" />
    <associate-document ref="associateDocument" @saveOK="onReload" />
    <template v-if="dataSource.length > 0">
      <fei-shu-document-new :token="dataSource[0].token" @onTitleChange="onTitleChange" />
    </template>
    <template v-else>
      <a-result>
        <template #icon>
          <a-empty description="未关联MRD" />
        </template>
        <template #extra>
          <a-space v-if="[131, 151].includes(status)">
            <a-button v-tc="{ name: '关联MRD' }" @click="onAssociate">关联MRD</a-button>
            <a-button v-tc="{ name: '新增MRD' }" type="primary" @click="onAdd">新增MRD</a-button>
          </a-space>
        </template>
      </a-result>
    </template>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import { disassociateDocument, updateDocument } from '@/api/business/document';

import FeiShuDocumentNew from '@/components/FeiShu/DocumentNew';
import DocumentEdit from '@/pages/business/document/components/DocumentEdit';
import AssociateDocument from '@/pages/business/requirement/components/AssociateDocument';
export default {
  components: { DocumentEdit, FeiShuDocumentNew, AssociateDocument },
  props: {
    sourceId: {
      type: [String, Number],
      default: null
    },
    dataSource: {
      type: [Array],
      default: () => {
        return [];
      }
    },
    status: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    onReload() {
      this.$emit('reload');
    },

    /**
     * 关联文档
     */
    onAssociate() {
      this.$nextTick(() => {
        this.$refs.associateDocument.onOpen(this.sourceId);
      });
    },

    /**
     * 添加MRD
     */
    onAdd() {
      this.$nextTick(() => {
        this.$refs.documentEdit.onOpen(this.sourceId);
      });
    },

    /**
     * 修改文档标题
     * @param {*} title
     */
    onTitleChange: debounce(function (title) {
      if (this.dataSource.length > 0 && this.dataSource[0].title !== title) {
        updateDocument({ id: this.dataSource[0].id, title: title }).then(() => {
          console.log('MRD标题变更成功');
        });
      }
    }, 500),

    /**
     * 解除关联
     */
    onDisassociate() {
      if (this.dataSource.length === 0) {
        this.$message.success('未绑定MRD');
        return;
      } else {
        const self = this;
        this.$confirm({
          title: '确认',
          content: '确认要解除与该MRD的关联关系吗?',
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          async onOk() {
            disassociateDocument({
              documentId: self.dataSource[0].id,
              requirementId: self.sourceId
            }).then(() => {
              self.$message.success('解除成功');
              self.$emit('reload');
            });
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped></style>
